import React from "react";

export const FilterFunnelIcon = (props: any) => {
  return (
    <svg className="App-SvgIcon" viewBox="0 0 14 14">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-160.000000, -169.000000)">
          <g transform="translate(37.000000, 166.000000)">
            <g transform="translate(123.000000, 3.000000)">
              <rect
                fillRule="nonzero"
                x="0"
                y="0"
                width="14"
                height="14"
              ></rect>
              <path
                d="M11.2042893,2.79571068 L8.09375,5.90625 L8.09375,5.90625 L8.09375,11.3350893 C8.09375,11.3903178 8.04897847,11.4350893 7.99375,11.4350893 C7.9655755,11.4350893 7.93870821,11.423204 7.91975599,11.4023566 L5.93225599,9.21610659 C5.91552218,9.1976994 5.90625,9.17371592 5.90625,9.14883931 L5.90625,5.90625 L5.90625,5.90625 L2.79571068,2.79571068 C2.75665825,2.75665825 2.75665825,2.69334175 2.79571068,2.65428932 C2.81446432,2.63553568 2.83989971,2.625 2.86642136,2.625 L11.1335786,2.625 C11.1888071,2.625 11.2335786,2.66977153 11.2335786,2.725 C11.2335786,2.75152165 11.223043,2.77695704 11.2042893,2.79571068 Z"
                stroke="#32325D"
                strokeWidth="0.9"
                fill={props.filled ? "#000" : "none"}
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
